// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ======================================================
   GLOBAL
====================================================== */
html {
  scroll-behavior: smooth;
}

body {
  font-family: "Segoe UI", sans-serif;
  color: #333;
  background: #fff;
}

img {
  max-width: 100%;
}

a {
  text-decoration: none;
}

/* ======================================================
   NAVBAR
====================================================== */
.navbar {
  background: #ffffff !important;
  padding: 12px 0;
  box-shadow: 0 3px 15px rgba(0, 0, 0, 0.08);
}

.logo {
  width: 260px;
  height: auto;
  transition: 0.3s;
}

.navbar-nav .nav-item {
  margin-left: 10px;
}

.nav-link {
  font-size: 15px;
  font-weight: 600;
  color: #222 !important;
}

.nav-link:hover {
  color: #8e0b56 !important;
}

.navbar .btn {
  font-weight: 600;
  padding: 8px 18px;
}

.btn-primary {
  background: #8e0b56;
  border-color: #8e0b56;
}

.btn-primary:hover {
  background: #6e0843;
  border-color: #6e0843;
}

.btn-outline-primary {
  color: #8e0b56;
  border-color: #8e0b56;
}

.btn-outline-primary:hover {
  background: #8e0b56;
  color: #fff;
}

/* ======================================================
   HERO
====================================================== */
.hero-section {
  position: relative;
  min-height: calc(100vh - 90px);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
}

.hero-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
}

.hero-box {
  position: relative;
  z-index: 5;
  color: #fff;
  padding: 60px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.08);
  -webkit-backdrop-filter: blur(5px);
          backdrop-filter: blur(5px);
}

.hero-badge {
  display: inline-block;
  background: #8e0b56;
  color: #fff;
  padding: 10px 25px;
  border-radius: 30px;
  margin-bottom: 30px;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.hero-box h1 {
  font-size: 50px;
  font-weight: 700;
  margin-bottom: 30px;
  line-height: 1.3;
}

.hero-box h4 {
  font-size: 26px;
  font-weight: 600;
  margin-bottom: 25px;
  color: #fff;
}

.hero-box p {
  color: rgba(255, 255, 255, 0.95);
  font-size: 18px;
  line-height: 1.9;
  margin-bottom: 20px;
}

.hero-btn {
  min-width: 220px;
  height: 55px;
  border-radius: 40px;
  font-size: 18px;
  font-weight: bold;
}

/* ======================================================
   FOOTER
====================================================== */
.footer {
  background: #10243f;
  color: #fff;
  padding: 60px 0 20px;
}

.footer-logo {
  width: 230px;
  background: #fff;
  padding: 12px;
  border-radius: 6px;
}

.footer p {
  color: rgba(255, 255, 255, 0.75);
  margin-bottom: 10px;
}

.footer hr {
  border-color: rgba(255, 255, 255, 0.15);
  margin: 30px 0;
}

.social-icons {
  margin-bottom: 15px;
}

.social-icons a {
  width: 42px;
  height: 42px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.12);
  border-radius: 50%;
  margin-right: 10px;
  color: #fff;
  transition: 0.3s;
}

.social-icons a:hover {
  background: #8e0b56;
  transform: translateY(-3px);
}

/* ======================================================
   RESPONSIVE
====================================================== */
@media (max-width: 1200px) {
  .hero-box h1 {
    font-size: 42px;
  }
}
@media (max-width: 991px) {
  .logo {
    width: 210px;
  }
  .navbar-nav {
    padding-top: 20px;
    text-align: center;
  }
  .navbar-nav .nav-item {
    margin: 8px 0;
  }
  .hero-section {
    min-height: auto;
    padding: 80px 0;
  }
  .hero-box {
    padding: 35px;
  }
  .hero-box h1 {
    font-size: 34px;
  }
  .hero-box h4 {
    font-size: 22px;
  }
}
@media (max-width: 768px) {
  .hero-box {
    padding: 25px;
  }
  .hero-box h1 {
    font-size: 28px;
  }
  .hero-box h4 {
    font-size: 18px;
  }
  .hero-box p {
    font-size: 15px;
  }
  .hero-btn {
    width: 100%;
  }
  .footer {
    text-align: center;
  }
  .footer-logo {
    margin-bottom: 25px;
  }
  .social-icons {
    margin-top: 20px;
  }
}
@media (max-width: 576px) {
  .logo {
    width: 180px;
  }
  .hero-section {
    padding: 50px 0;
  }
  .hero-box h1 {
    font-size: 24px;
  }
  .hero-box h4 {
    font-size: 16px;
  }
  .hero-badge {
    font-size: 13px;
    padding: 8px 18px;
  }
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/website/home/home.component.scss"],"names":[],"mappings":"AAAA;;wDAAA;AAIA;EACE,uBAAA;AAAF;;AAGA;EACE,mCAAA;EACA,WAAA;EACA,gBAAA;AAAF;;AAGA;EACE,eAAA;AAAF;;AAGA;EACE,qBAAA;AAAF;;AAGA;;wDAAA;AAIA;EACE,8BAAA;EACA,eAAA;EACA,0CAAA;AADF;;AAIA;EACE,YAAA;EACA,YAAA;EACA,gBAAA;AADF;;AAIA;EACE,iBAAA;AADF;;AAIA;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;AADF;;AAIA;EACE,yBAAA;AADF;;AAIA;EAEE,gBAAA;EACA,iBAAA;AAFF;;AAKA;EACE,mBAAA;EACA,qBAAA;AAFF;;AAKA;EACE,mBAAA;EACA,qBAAA;AAFF;;AAKA;EACE,cAAA;EACA,qBAAA;AAFF;;AAKA;EACE,mBAAA;EACA,WAAA;AAFF;;AAKA;;wDAAA;AAIA;EAEE,kBAAA;EAEA,8BAAA;EAIA,sBAAA;EAEA,2BAAA;EAEA,4BAAA;EAEA,aAAA;EAEA,mBAAA;AAZF;;AAgBA;EAEE,kBAAA;EAEA,QAAA;EAEA,8BAAA;AAhBF;;AAoBA;EAEE,kBAAA;EAEA,UAAA;EAEA,WAAA;EAEA,aAAA;EAEA,mBAAA;EAEA,qCAAA;EAEA,kCAAA;UAAA,0BAAA;AAxBF;;AA4BA;EAEE,qBAAA;EAEA,mBAAA;EAEA,WAAA;EAEA,kBAAA;EAEA,mBAAA;EAEA,mBAAA;EAEA,gBAAA;EAEA,qBAAA;AAjCF;;AAqCA;EAEE,eAAA;EAEA,gBAAA;EAEA,mBAAA;EAEA,gBAAA;AAtCF;;AA0CA;EAEE,eAAA;EAEA,gBAAA;EAEA,mBAAA;EAEA,WAAA;AA3CF;;AA+CA;EAEE,gCAAA;EAEA,eAAA;EAEA,gBAAA;EAEA,mBAAA;AAhDF;;AAoDA;EAEE,gBAAA;EAEA,YAAA;EAEA,mBAAA;EAEA,eAAA;EAEA,iBAAA;AAtDF;;AA0DA;;wDAAA;AAIA;EAEE,mBAAA;EAEA,WAAA;EAEA,oBAAA;AA3DF;;AA+DA;EAEE,YAAA;EAEA,gBAAA;EAEA,aAAA;EAEA,kBAAA;AAhEF;;AAoEA;EAEE,gCAAA;EAEA,mBAAA;AAnEF;;AAuEA;EAEE,uCAAA;EAEA,cAAA;AAtEF;;AA0EA;EAEE,mBAAA;AAxEF;;AA4EA;EAEE,WAAA;EAEA,YAAA;EAEA,oBAAA;EAEA,mBAAA;EAEA,uBAAA;EAEA,qCAAA;EAEA,kBAAA;EAEA,kBAAA;EAEA,WAAA;EAEA,gBAAA;AAnFF;;AAuFA;EAEE,mBAAA;EAEA,2BAAA;AAtFF;;AA0FA;;wDAAA;AAIA;EAEE;IAEE,eAAA;EA1FF;AACF;AA+FA;EAEE;IAEE,YAAA;EA/FF;EAmGA;IAEE,iBAAA;IAEA,kBAAA;EAnGF;EAuGA;IAEE,aAAA;EAtGF;EA0GA;IAEE,gBAAA;IAEA,eAAA;EA1GF;EA8GA;IAEE,aAAA;EA7GF;EAiHA;IAEE,eAAA;EAhHF;EAoHA;IAEE,eAAA;EAnHF;AACF;AAwHA;EAEE;IAEE,aAAA;EAxHF;EA4HA;IAEE,eAAA;EA3HF;EA+HA;IAEE,eAAA;EA9HF;EAkIA;IAEE,eAAA;EAjIF;EAqIA;IAEE,WAAA;EApIF;EAwIA;IAEE,kBAAA;EAvIF;EA2IA;IAEE,mBAAA;EA1IF;EA8IA;IAEE,gBAAA;EA7IF;AACF;AAkJA;EAEE;IAEE,YAAA;EAlJF;EAsJA;IAEE,eAAA;EArJF;EAyJA;IAEE,eAAA;EAxJF;EA4JA;IAEE,eAAA;EA3JF;EA+JA;IAEE,eAAA;IAEA,iBAAA;EA/JF;AACF;AAEA,gwSAAgwS","sourcesContent":["/* ======================================================\n   GLOBAL\n====================================================== */\n\nhtml {\n  scroll-behavior: smooth;\n}\n\nbody {\n  font-family: \"Segoe UI\", sans-serif;\n  color: #333;\n  background: #fff;\n}\n\nimg {\n  max-width: 100%;\n}\n\na {\n  text-decoration: none;\n}\n\n/* ======================================================\n   NAVBAR\n====================================================== */\n\n.navbar {\n  background: #ffffff !important;\n  padding: 12px 0;\n  box-shadow: 0 3px 15px rgba(0, 0, 0, .08);\n}\n\n.logo {\n  width: 260px;\n  height: auto;\n  transition: .3s;\n}\n\n.navbar-nav .nav-item {\n  margin-left: 10px;\n}\n\n.nav-link {\n  font-size: 15px;\n  font-weight: 600;\n  color: #222 !important;\n}\n\n.nav-link:hover {\n  color: #8e0b56 !important;\n}\n\n.navbar .btn {\n  // border-radius: 30px;\n  font-weight: 600;\n  padding: 8px 18px;\n}\n\n.btn-primary {\n  background: #8e0b56;\n  border-color: #8e0b56;\n}\n\n.btn-primary:hover {\n  background: #6e0843;\n  border-color: #6e0843;\n}\n\n.btn-outline-primary {\n  color: #8e0b56;\n  border-color: #8e0b56;\n}\n\n.btn-outline-primary:hover {\n  background: #8e0b56;\n  color: #fff;\n}\n\n/* ======================================================\n   HERO\n====================================================== */\n\n.hero-section {\n\n  position: relative;\n\n  min-height: calc(100vh - 90px);\n\n  //background-image: url(\"../../../../assets/home/img/top-banner.jpg\");\n\n  background-size: cover;\n\n  background-position: center;\n\n  background-repeat: no-repeat;\n\n  display: flex;\n\n  align-items: center;\n\n}\n\n.hero-overlay {\n\n  position: absolute;\n\n  inset: 0;\n\n  background: rgba(0,0,0,.60);\n\n}\n\n.hero-box {\n\n  position: relative;\n\n  z-index: 5;\n\n  color: #fff;\n\n  padding: 60px;\n\n  border-radius: 20px;\n\n  background: rgba(255,255,255,.08);\n\n  backdrop-filter: blur(5px);\n\n}\n\n.hero-badge {\n\n  display: inline-block;\n\n  background: #8e0b56;\n\n  color: #fff;\n\n  padding: 10px 25px;\n\n  border-radius: 30px;\n\n  margin-bottom: 30px;\n\n  font-weight: 600;\n\n  letter-spacing: .5px;\n\n}\n\n.hero-box h1 {\n\n  font-size: 50px;\n\n  font-weight: 700;\n\n  margin-bottom: 30px;\n\n  line-height: 1.3;\n\n}\n\n.hero-box h4 {\n\n  font-size: 26px;\n\n  font-weight: 600;\n\n  margin-bottom: 25px;\n\n  color: #fff;\n\n}\n\n.hero-box p {\n\n  color: rgba(255,255,255,.95);\n\n  font-size: 18px;\n\n  line-height: 1.9;\n\n  margin-bottom: 20px;\n\n}\n\n.hero-btn {\n\n  min-width: 220px;\n\n  height: 55px;\n\n  border-radius: 40px;\n\n  font-size: 18px;\n\n  font-weight: bold;\n\n}\n\n/* ======================================================\n   FOOTER\n====================================================== */\n\n.footer {\n\n  background: #10243f;\n\n  color: #fff;\n\n  padding: 60px 0 20px;\n\n}\n\n.footer-logo {\n\n  width: 230px;\n\n  background: #fff;\n\n  padding: 12px;\n\n  border-radius: 6px;\n\n}\n\n.footer p {\n\n  color: rgba(255,255,255,.75);\n\n  margin-bottom: 10px;\n\n}\n\n.footer hr {\n\n  border-color: rgba(255,255,255,.15);\n\n  margin: 30px 0;\n\n}\n\n.social-icons {\n\n  margin-bottom: 15px;\n\n}\n\n.social-icons a {\n\n  width: 42px;\n\n  height: 42px;\n\n  display: inline-flex;\n\n  align-items: center;\n\n  justify-content: center;\n\n  background: rgba(255,255,255,.12);\n\n  border-radius: 50%;\n\n  margin-right: 10px;\n\n  color: #fff;\n\n  transition: .3s;\n\n}\n\n.social-icons a:hover {\n\n  background: #8e0b56;\n\n  transform: translateY(-3px);\n\n}\n\n/* ======================================================\n   RESPONSIVE\n====================================================== */\n\n@media (max-width: 1200px) {\n\n  .hero-box h1 {\n\n    font-size: 42px;\n\n  }\n\n}\n\n@media (max-width: 991px) {\n\n  .logo {\n\n    width: 210px;\n\n  }\n\n  .navbar-nav {\n\n    padding-top: 20px;\n\n    text-align: center;\n\n  }\n\n  .navbar-nav .nav-item {\n\n    margin: 8px 0;\n\n  }\n\n  .hero-section {\n\n    min-height: auto;\n\n    padding: 80px 0;\n\n  }\n\n  .hero-box {\n\n    padding: 35px;\n\n  }\n\n  .hero-box h1 {\n\n    font-size: 34px;\n\n  }\n\n  .hero-box h4 {\n\n    font-size: 22px;\n\n  }\n\n}\n\n@media (max-width: 768px) {\n\n  .hero-box {\n\n    padding: 25px;\n\n  }\n\n  .hero-box h1 {\n\n    font-size: 28px;\n\n  }\n\n  .hero-box h4 {\n\n    font-size: 18px;\n\n  }\n\n  .hero-box p {\n\n    font-size: 15px;\n\n  }\n\n  .hero-btn {\n\n    width: 100%;\n\n  }\n\n  .footer {\n\n    text-align: center;\n\n  }\n\n  .footer-logo {\n\n    margin-bottom: 25px;\n\n  }\n\n  .social-icons {\n\n    margin-top: 20px;\n\n  }\n\n}\n\n@media (max-width: 576px) {\n\n  .logo {\n\n    width: 180px;\n\n  }\n\n  .hero-section {\n\n    padding: 50px 0;\n\n  }\n\n  .hero-box h1 {\n\n    font-size: 24px;\n\n  }\n\n  .hero-box h4 {\n\n    font-size: 16px;\n\n  }\n\n  .hero-badge {\n\n    font-size: 13px;\n\n    padding: 8px 18px;\n\n  }\n\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
